import { SerializedFarmConfig } from 'config/constants/types'
import { useTotalAllocPoint } from 'state/farms/useTotalAllocPoint'
import { getCraftsmanContract, getCraftsmanV2Contract } from 'utils/contractHelpers'
import fetchFarmWithMulticallsback from 'state/farms/fetchFarm'
import { runMultiEncodedcallsbacks } from 'utils/multicall'
import type { SerializedFarm, SerializedFarmData } from 'state/types'

const fetchFarms = async (farmsToFetch: SerializedFarmConfig[]): Promise<SerializedFarm[]> => {
  const fetchFarmParams = {
    craftsmanContract: getCraftsmanContract(),
    craftsmanV2Contract: getCraftsmanV2Contract(),
    totalAllocPoint: (await useTotalAllocPoint.getState().getLoadedValue()).totalAllocPointBn,
  }
  const fetchedFarmDatas = await runMultiEncodedcallsbacks<SerializedFarmData>(
    farmsToFetch.map((farmConfig) => fetchFarmWithMulticallsback(farmConfig, fetchFarmParams)),
  )
  const serializedFarmWithData = farmsToFetch.map((farmConfig, i) => {
    const farmData = fetchedFarmDatas[i]
    return {
      ...farmConfig,
      ...farmData,
    }
  })

  return serializedFarmWithData
}

export default fetchFarms
